import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AdministradorService } from 'src/app/services/administrador.service';

@Component({
  selector: 'app-administrador-distribuidor-nuevo',
  templateUrl: './administrador-distribuidor-nuevo.component.html',
  styleUrls: ['./administrador-distribuidor-nuevo.component.scss'],
  providers: [MessageService]
})
export class AdministradorDistribuidorNuevoComponent {
  formDistribuidor: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private administradorService: AdministradorService
  ) {
    this.formDistribuidor = this.createDistribuidorFormulario();

  }
  onSubmit(): void {
    if (this.formDistribuidor.valid) {
      console.log('Formulario enviado:', this.formDistribuidor.value);
      this.administradorService
        .setNuevoDistribuidor(this.formDistribuidor.value)
        .subscribe({
          next: (resp) => {
            console.log(resp);
            this.showSuccess('Registrado con éxito');
            this.router.navigate(['/administrador/distribuidores']);
          },
          error: (err) => { console.error(err); }
        });

    } else {
      this.showError('Por favor complete todos los campos requeridos');
      this.markFormGroupTouched(this.formDistribuidor);
    }
  }

  createDistribuidorFormulario(): FormGroup {
    return this.fb.group({
      // Datos generales del usuario
      id: [0],
      nombre: ['', Validators.required],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      telefonoMovil: [''],
      correo: ['', [Validators.required, Validators.email]],
      activo: [1],
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  cancelar(): void {
    this.router.navigate(['/administrador'])
  }

  get f() {
    return this.formDistribuidor.controls;
  }

}

